import { render, staticRenderFns } from "./RefundVoid.vue?vue&type=template&id=8b70c1ca&"
import script from "./RefundVoid.vue?vue&type=script&lang=js&"
export * from "./RefundVoid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports